import React, { FC } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useStyles } from './styles';
import { CircleTrashIcon } from '../../../../components';
import { useCommonStyles } from '../../../../styles';

interface Props {
  translation: any;
  open: boolean;
  handleCancel: () => void;
  onDelete: () => void;
}

export const DeleteConfirmationDialog: FC<Props> = ({ translation, open, handleCancel, onDelete }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();

  return (
    <Dialog onClose={handleCancel} open={open} classes={{ paper: classes.dialog }}>
      <DialogTitle disableTypography className={commonClasses.dialogHeader}>
        <Grid container spacing={1} justify="flex-end">
          <IconButton className={commonClasses.dialogCloseBtn} onClick={handleCancel}>
            <Close />
          </IconButton>
        </Grid>
      </DialogTitle>
      <Grid container direction="column" alignItems="center" justify="center" className={commonClasses.dialogContent} spacing={1}>
        <Grid item>
          <CircleTrashIcon />
        </Grid>
        <Grid item>
          <Typography className={commonClasses.dialogTitle}>{translation.confirm_campaign_delete}</Typography>
        </Grid>
        <Grid item>
          <Typography className={commonClasses.dialogBody}>{translation.confirm_campaign_delete_content}</Typography>
        </Grid>
      </Grid>
      <DialogActions className={commonClasses.dialogAction}>
        <Button onClick={onDelete} fullWidth className={commonClasses.negativeDialogBtn}>
          {translation.text_330}
        </Button>
        <Button onClick={handleCancel} fullWidth className={commonClasses.cancelDialogBtn}>
          {translation.text_658}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
